import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { CreditosConEmpleadosListComponent } from './creditos-con-empleados-list.component';
import { CreditosConEmpleadosService } from './creditos-con-empleados.service';

@Component({
    selector: 'convfact-creditosconempleadosdelete',
    templateUrl: './creditos-con-empleados-dialog-delete.component.html',
    styleUrls: ['./creditos-con-empleados.component.css'],
    standalone: false
})
export class CreditosConEmpleadosDialogDeleteComponent {

  public uid: string = this.data.uid;
  public response_message: string;
  public response_error: boolean;

  constructor(
    public dialogRef: MatDialogRef<CreditosConEmpleadosListComponent>,
    public creditosConEmpleadosService: CreditosConEmpleadosService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
  ) { }

  public delete() {
    this.creditosConEmpleadosService.delete(this.uid)
      .then(res => {
        this.response_message = "El crédito se ha eliminado correctamente";
        this.response_error = false;
      }).catch(err => {
        this.response_message = "Ha ocurrido un error al eliminar el credito";
        this.response_error = true;
      });
  }

  public closeDialog() {
    this.dialogRef.close();
  }
}
